export const getArchiveSoftBlockStatuses = (records = []) => {
  const statusNames = new Set();

  records.forEach((record) => {
    const currentReferralStatusId = record?.referral_status?.referral_status_id;
    if (!currentReferralStatusId) return;

    const matchingStatus = record?.referral_statuses?.find(
      (status) => String(status?.id) === String(currentReferralStatusId),
    );

    if (matchingStatus?.soft_block_archive === true && matchingStatus.name) {
      statusNames.add(matchingStatus.name);
    }
  });

  return Array.from(statusNames);
};

export default getArchiveSoftBlockStatuses;
